export default {"src":"/_next/static/media/arrow-down-bold-dark-blue.03055d07.svg","height":8,"width":12,"blurWidth":0,"blurHeight":0};